import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import { Link } from 'react-router-dom'

import TitleIcon from '@material-ui/icons/Dashboard'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'


const styles = {
    root: {
        flexGrow: 1,
    },
    card: {
        position: 'relative',
        flex: '1 1 auto',
        padding : 20,
        width : 'auto'
    },
    titleContainer : {
        borderBottom: '1px solid #A8A8A8',
        padding: '20px 0',
        marginBottom: 20,
    },
    title : {
        display: 'inline-flex',
        verticalAlign: 'middle',
        alignItems: 'center',
        fontSize: 23,
        '& svg' : { color: '#019EAC' }
    },
    paper : {
        padding : 25,
        backgroundColor : '#FCFCFF',
        color: '#33C2D5',
        '& .icon' : { fontSize: 35 },
        '& .title' : {
            borderBottom : '1px solid #33C2D5',
            padding : '5px 0',
            marginBottom: 5,
            fontSize: 18,
        },
        '& .item-link' : {
            color : '#464748',
            fontSize: 14,
            display: 'flex',
            margin: '5px 0',
            padding: '6px 12px 8px 12px',
            textDecoration: 'none',
            borderRadius: 6,
            '&:hover' : { backgroundColor: '#6ED4E1', color : '#fff' },
            '&.subitem' : {
                fontSize: 13,
            }

        },
        '& .subitems-section' : {
            paddingLeft : 20,
        },
    }
};



class GroupItemsList extends Component {

    state = {}

    handleToggle = menu => {
        this.setState(state => ({ [menu]: !state[menu] }));
    }

    groupItemLink = (item, isSubitem=false) => {
        if(item.link){
            return (
                <Link 
                    key={item.link}
                    className={`item-link ${isSubitem ? "subitem" : ""}`}
                    to={item.link}
                >{item.name}</Link> 
            )
        }
        else if(item.subitems){
            return (
                <div key={item.name}>
                    <span 
                        onClick={() => this.handleToggle(item.subitemId)}
                        className={`item-link ${isSubitem ? "subitem" : ""}`}
                    > {item.name} {
                        this.state[item.subitemId]
                            ? <ExpandLessIcon />
                            : <ExpandMoreIcon />
                    }
                    </span>
                    {this.state[item.subitemId] &&
                        <div className={"subitems-section"}>
                            {item.subitems.map(item => (
                                this.groupItemLink(item, true)
                            ))}
                        </div>
                    }
                </div>
            )
        }else{
            return (<div key={item.link}></div>)
        }
    }

    render() {
        const { classes, title, groupItems} = this.props
        return (
            <Card className={classes.card}>
                <div className={classes.titleContainer}>
                    <Typography className={classes.title}>
                        <TitleIcon /> {title}
                    </Typography>
                </div>
                <div className={classes.root}>
                    <Grid container spacing={24}>
                        {groupItems.map(c => (
                        <Grid key={c.title} item xs={12} md={2} lg={4}>
                            <Paper className={classes.paper} >
                                <span className={`icon icon-${c.icon}`}></span>
                                <div className={'title'}>{c.title}</div>
                                <div>
                                    {c.items.map(item => (
                                        this.groupItemLink(item)
                                    ))}
                                </div>
                            </Paper>
                        </Grid>))}
                    </Grid>
                </div>
            </Card>
        )
    }
}

export default withStyles(styles)(GroupItemsList)
